import { CourseCatalogApi } from "@/api";

export async function getCoursesData() {
  const { data } = await CourseCatalogApi.getCoursesData();
  return data;
}
